import * as api from "../api";
import WorksComputedMix from "./WorksComputedMix";

export default {
  data() {
    return {
      to_artist_id: $('#app-wrapper').attr('artist_id'),
      to_gallery_id: $('#app-wrapper').attr('gallery_id'),
      to_exposition_id: $('#app-wrapper').attr('exposition_id'),
      to_place_id: $('#app-wrapper').attr('place_id'),
      to_set_id: $('#app-wrapper').attr('set_id'),
      is_copyright: false,

      filters: {
        dt_start: '',
        dt_finish: ''
      },
    }
  },
  props:{
    is_mark_work_pro:{//помечать работы pro аккаунтов
      type: Boolean,
      default: true
    },
  },
  mixins: [WorksComputedMix],

  methods   :{
    filterChanged: function (data, event) {
      this.filters = data;
    },

    init_copyright: function(){
      this.is_copyright=false;

      if ( this.to_artist_id>0 ){
        var url = '/action/vue/artists/search-id';

        api.get(url, {id: this.to_artist_id}).then(response => {
          this.is_copyright=(response.data.is_copyright=='y');
        }).catch(e => {
          console.log(e)
        });
      }
    },
  },
  created(){
    this.$nextTick(()=>{
      this.init_copyright();
    });
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/WorksMix.js
// module id = null
// module chunks = 